/**
 * Widget library list avatars: inline SVG data URIs (no external fetch; avoids broken Unsplash/hotlink).
 * Keys match `widget.type` from the catalog.
 */

const BRAND = '#2173FF';
const MUTED = '#94A3B8';
const BG = '#F1F5F9';

function svgDataUri(svg) {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg.trim())}`;
}

const WIDGET_LIBRARY_AVATAR_BY_TYPE = Object.freeze({
  notes: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path fill="${BRAND}" d="M22 18h20a2 2 0 0 1 2 2v26l-4-3h-18a2 2 0 0 1-2-2V20a2 2 0 0 1 2-2Z" opacity=".9"/>
  <path stroke="#fff" stroke-width="2" stroke-linecap="round" d="M26 26h12M26 32h8"/>
</svg>`),

  activity: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path stroke="${BRAND}" stroke-width="2.5" stroke-linecap="round" d="M18 38c4-8 10-12 14-12s10 4 14 12"/>
  <circle cx="32" cy="24" r="4" fill="${BRAND}"/>
</svg>`),

  emails: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path stroke="${BRAND}" stroke-width="2" d="M20 24h24v16H20z"/>
  <path stroke="${BRAND}" stroke-width="2" d="M20 24l12 9 12-9"/>
</svg>`),

  chat: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path fill="${BRAND}" d="M18 22h22a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H26l-6 5v-5h-2a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3Z" opacity=".9"/>
  <path stroke="#fff" stroke-width="1.5" stroke-linecap="round" d="M24 30h14M24 34h8"/>
</svg>`),

  appointments: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path stroke="${BRAND}" stroke-width="2" d="M22 20h20a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V22a2 2 0 0 1 2-2Z"/>
  <path stroke="${BRAND}" stroke-width="2" d="M20 28h24"/>
  <path fill="${BRAND}" d="M28 34h4v4h-4z"/>
</svg>`),

  tasks: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path stroke="${BRAND}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" d="M22 28l6 6 14-14"/>
  <path stroke="${MUTED}" stroke-width="2" d="M22 40h20"/>
</svg>`),

  followUps: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <circle cx="32" cy="32" r="12" stroke="${BRAND}" stroke-width="2"/>
  <path stroke="${BRAND}" stroke-width="2" stroke-linecap="round" d="M32 24v8l5 3"/>
</svg>`),

  pipeline: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path fill="${BRAND}" d="M22 40V28h6v12h-6Zm10 8V20h6v28h-6Zm10-6V32h6v10h-6Z" opacity=".85"/>
</svg>`),

  conversionFunnel: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path fill="${BRAND}" d="M20 20h24l-6 10h-12l-6-10Zm6 12h12l-4 8h-4l-4-8Zm4 10h8l-4 6h0l-4-6Z" opacity=".9"/>
</svg>`),

  performanceScore: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path stroke="${BRAND}" stroke-width="2" stroke-linecap="round" d="M18 40c4-10 10-14 14-14s10 4 14 14"/>
  <path stroke="${BRAND}" stroke-width="3" stroke-linecap="round" d="M32 26v8"/>
</svg>`),

  aiInsights: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <path fill="${BRAND}" d="M32 18l2 6h6l-5 4 2 6-5-4-5 4 2-6-5-4h6l2-6Z"/>
  <circle cx="32" cy="44" r="3" fill="${MUTED}"/>
</svg>`),

  sentiment: svgDataUri(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
  <rect width="64" height="64" rx="32" fill="${BG}"/>
  <circle cx="24" cy="28" r="3" fill="${BRAND}"/>
  <circle cx="40" cy="28" r="3" fill="${BRAND}"/>
  <path stroke="${BRAND}" stroke-width="2" stroke-linecap="round" d="M24 40c3 4 13 4 16 0"/>
</svg>`),
});

export function getWidgetLibraryAvatarSrc(widgetType) {
  if (widgetType && WIDGET_LIBRARY_AVATAR_BY_TYPE[widgetType]) {
    return WIDGET_LIBRARY_AVATAR_BY_TYPE[widgetType];
  }
  return WIDGET_LIBRARY_AVATAR_BY_TYPE.notes;
}
